/**
 * Dimming for panels that show the previous filter's numbers while the new
 * ones load.
 *
 * A filter change keeps what is on screen until the new answer lands
 * (keepWhileOnlyFilterChanges), so the page no longer blanks. The numbers
 * underneath are briefly the OLD ones, and the page must say so: dimmed, with
 * `aria-busy` for assistive technology, never presented as current. The delay
 * on the dim keeps a fast refetch from flickering.
 *
 * These go ON an existing box (the dashboard grid's rows, whose order a test
 * pins, must stay its direct children); `UpdatingFade` wraps panels that have
 * no box of their own.
 */
export function updatingSx(updating: boolean): { opacity: number; transition: string } {
  return {
    opacity: updating ? 0.55 : 1,
    transition: updating ? 'opacity 200ms ease 150ms' : 'opacity 150ms ease',
  }
}

export function updatingProps(updating: boolean): { 'aria-busy': boolean; 'data-updating': 'true' | 'false' } {
  return { 'aria-busy': updating, 'data-updating': updating ? 'true' : 'false' }
}
